import { MutationTree } from 'vuex';
import { State } from '@/stores/user/state';
import { User } from '@/models/user';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';
import { storeCustomerIdInSessionStorage, storeSiteIdInSessionStorage } from '@/current-customer-site';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setUser = (state: State, user: User) => {
        state.user = user;
    }
    public setCurrentCustomer = (state: State, customer: Customer | null) => {
        state.currentCustomerId = customer?.id || null;
        if (customer !== null) {
            storeCustomerIdInSessionStorage(customer.id!);
        }
    }
    public setCurrentSite = (state: State, site: Site | null) => {
        state.currentSiteId = site?.id || null;
        if (site !== null) {
            storeSiteIdInSessionStorage(site.id!);
        }
    }
}
